import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import publicMainStyle from "assets/jss/components/publicMainStyles";
import { makeStyles, Button } from "@material-ui/core";
import { PRIVACY_STATEMENT } from "utils/languages";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { LoadingFakeText } from "@totalsoft/rocket-webapp-components-deprecated";
import Html2ReactParser from "html-to-react/lib/parser";
import cx from "classnames";
import logo from "assets/img/logo.svg";
import { defaultMiniLogo } from "constants/defaultMiniLogo";
import { useTheme } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Close } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(publicMainStyle);

export const PrivacyStatement = (props) => {
  const { onOpenStatement } = props;

  const classes = useStyles();
  const theme = useTheme();
  const { miniLogo } = theme;
  const [template, setTemplate] = useState();
  const htmlToReactParser = new Html2ReactParser();
  const { i18n } = useTranslation();

  const { loading } = useQueryWithErrorHandling(PRIVACY_STATEMENT, {
    variables: { code: "PrivacyStatementTemplate", languageCode: i18n.language },
    onCompleted: (data) => {
      const isDefaultMiniLogo = miniLogo === defaultMiniLogo;
      const webTemplate = data?.webTemplate
        .replace("img/logo-dl.png?version=@VCP.MvcApplication.ResourceVersion", isDefaultMiniLogo ? logo : miniLogo)
        .replace('class="logo"', 'style="width: 200px"')
        .replace('width="200"', isDefaultMiniLogo ? 'height="70px"' : 'width="200px"');
      setTemplate(webTemplate);
    },
  });

  if (loading) return <LoadingFakeText />;

  return (
    <Container className={classes.root}>
      <Container className={cx(classes.loginForm, classes.statement)} maxWidth="md">
        <Button color="primary" size="large" onClick={onOpenStatement} className={classes.closeButton}>
          <Close />
        </Button>
        <div className={classes.paper}>{htmlToReactParser.parse(template)}</div>
      </Container>
    </Container>
  );
};

PrivacyStatement.propTypes = {
  onOpenStatement: PropTypes.func.isRequired,
};
